import React, { createContext, useCallback, useContext, useState, } from 'react';
import { useVideoComponent } from '../../adapters';
import { useAppDispatch } from '../../redux/hooks';
import { showCaptions } from '../../redux/slices/closedCaptions';
export default function AudioPlayer({ children, }) {
    const dispatch = useAppDispatch();
    const VideoComponent = useVideoComponent();
    const [audioProps, setAudioProps] = useState();
    const playAudio = useCallback((audio) => new Promise((resolve) => {
        setAudioProps({
            src: audio.audio,
            trackSrc: audio.cc,
            onEnded: resolve,
        });
    }), []);
    return (React.createElement(PlayAudioContext.Provider, { value: playAudio },
        children,
        audioProps && (React.createElement(VideoComponent, { audioOnly: true, onCueChange: (captions) => dispatch(showCaptions(captions)), ...audioProps }))));
}
const PlayAudioContext = createContext(null);
export function usePlayAudio() {
    const playAudio = useContext(PlayAudioContext);
    if (!playAudio) {
        throw 'usePlayAudio must be used within a child of <AudioPlayer>';
    }
    return playAudio;
}
//# sourceMappingURL=AudioPlayer.js.map